import React from 'react';

import MadlibApplet from 'components/applets/madlib';
import useContentfulRenderer from 'hooks/useContentfulRenderer';
import { ChallengeApplet } from 'models/ChallengeApplet';
import { AppletContentful } from 'models/AppletContentful';

type MadlibAppletSubmissionProps = {
  applet: ChallengeApplet;
  appletDef: AppletContentful;
};

const MadlibAppletSubmission = ({ applet, appletDef }: MadlibAppletSubmissionProps) => {
  const renderedMadlibSentence = useContentfulRenderer(appletDef.madlibSentence, {
    madlibAnswers: applet.madlibAnswers,
  });

  return <MadlibApplet madlibSentence={renderedMadlibSentence} disabled />;
};

export default MadlibAppletSubmission;
